import { Subject, Subscription, catchError, filter, finalize, interval, lastValueFrom, map, of, race, takeUntil, timeout, timer } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Deployment } from 'src/app/core/models/deployment';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { NavigationService } from '../../../../core/services/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { CloudProvider } from '../../../../core/models/cloudProvider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeleteDeploymentComponent } from '../../modals/delete-deployment/delete-deployment.component';
import { StorageService } from 'src/app/core/services/storage.service';
import { AddDeploymentComponent } from '../../modals/add-deployment/add-deployment.component';
import { HeaderService } from 'src/app/core/services/header.service';
import { JobOutputDialogComponent } from 'src/app/modules/job/modals/jobActions/job-output-dialog/job-output-dialog.component';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';
import { AuthType, CloudTypes, Entities } from 'src/app/core/models/globals';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Component, Inject, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { ConcurrentUsersService } from '../../../../core/services/concurrent-users.service';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { EnvironmentService } from '../../../../core/services/environment.service';
import { UserService } from '../../../../core/services/user.service';
import { User } from '@auth0/auth0-angular';
import { UserRoleNames } from '../../../../core/models/users';
import {
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
  MSAL_GUARD_CONFIG,
} from "@azure/msal-angular";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  RedirectRequest,
} from "@azure/msal-browser";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  isLoggedIn: boolean = false;
  isJobOperator: boolean = false;
  authType = this.authenticationService.getAuthenticationType();
  isClientLogin = this.router.url.includes("desktopapp"); // check for desktopapp
  isDesktopClientLogin = this.router.url.includes("desktopapp");
  vdiModeOnly = this.env.envVariables.vdiModeOnly;

  clickedDepName: string = '';
  dataReloadSubscription: Subscription;
  universalSub: Subscription;
  deployments: Deployment[];
  dataEmpty: boolean = false;
  cloudProviders: CloudProvider[];
  currentEntity: string;
  userDepCheck: Subscription;
  isPathConfigurator: boolean = false;
  sortName = 0;
  sortLocation = 0;
  sortScheduler = 0;
  sortInfrastructure = 0;
  sortStatus = 0;
  isUserGlobalAdmin: boolean = this.authenticationService.isUserGlobalAdmin;
  hover: boolean[] = [false, false, false];
  private readonly _destroying$ = new Subject<void>();
  constructor(
    private spiner: NgxSpinnerService,
    private router: Router,
    public depService: DeploymentService,
    private route: ActivatedRoute,
    private navService: NavigationService,
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
    private storageService: StorageService,
    private headerService: HeaderService,
    private syncConfig: SyncConfigService,
    private authenticationService: AuthenticationService,
    private oauthService: OAuthService,
    private env: EnvironmentService,
    public userService: UserService,
    private _concurrentService: ConcurrentUsersService,
    private configEntityService: ConfigEntityService,
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
  ) { }

  async ngOnInit() {
    if (this.authenticationService.logInPageRedirect == false) {
      this.isLoggedIn = localStorage.getItem("currentUser") ? true : false;
      this.isJobOperator = this.authenticationService.getRole() === UserRoleNames.JobOperator;
    }
    if (this.authType == AuthType.PingIdentity) {
      if (this.authenticationService.isDefaultAdminLogin) {
        this.defaultAdminLogin();
      }
      else {
        let userObj: User = {
          id: 1,
          username: "",
          password: "",
          firstName: "",
          lastName: "",
          role: "",
          token: "",
          isUserVdiOnly: false,
        };

        console.log('Has valid access token:', this.oauthService.hasValidAccessToken());
        console.log('Access token:', this.oauthService.getAccessToken());
        console.log('ID token:', this.oauthService.getIdToken());

        await this.oauthService.loadDiscoveryDocumentAndTryLogin();
        if (this.oauthService.hasValidAccessToken()) {
          const claims = this.oauthService.getIdentityClaims();
          console.log('Claims:', claims);
          if (claims) {
            this.userService
              .getUserRole(claims.preferred_username)
              .subscribe({
                next: async (data) => {
                  let roleNum = Number(data);
                  switch (roleNum) {
                    case 0:
                      userObj.role = UserRoleNames.GlobalAdmin;
                      break;
                    case 1:
                      userObj.role = UserRoleNames.DeploymentAdmin;
                      break;
                    case 2:
                      userObj.role = UserRoleNames.PowerUser;
                      break;
                    case 3:
                      userObj.role = UserRoleNames.JobOperator;
                      break;
                    case 4:
                      userObj.role = UserRoleNames.Reader;
                      break;
                    default:
                      userObj.role = "";
                      break;
                  }
                  userObj.username = claims.preferred_username;
                  userObj.firstName = claims.given_name;
                  userObj.lastName = claims.family_name;
                  userObj.token = this.oauthService.getAccessToken();

                  await this.handleAfterLogin(userObj);
                  this.universalSub = this.navService.breadcrumbEntity.subscribe(x => {
                    if (this.currentEntity != x) {
                      this.currentEntity = x;
                    }
                  });
                },
                error: () => {
                  this.oauthService.logOut();
                },
              });
          } else {
            this.oauthService.initLoginFlow();
          }
        }
        else {
          this.oauthService.initLoginFlow();
        }
      }
    }
    else if (this.authType == AuthType.AzureAD) {
      if (this.authenticationService.isDefaultAdminLogin) {
        this.defaultAdminLogin();
      }
      else {        
        let userObj: User = {
          id: 1,
          username: "",
          password: "",
          firstName: "",
          lastName: "",
          role: "",
          token: "",
          isUserVdiOnly: false,
        };

        this.msalBroadcastService.msalSubject$
          .pipe(
            filter(
              (msg: EventMessage) =>
                msg.eventType === EventType.LOGIN_SUCCESS ||
                msg.eventType === EventType.SSO_SILENT_SUCCESS
            )
          )
          .subscribe((result: EventMessage) => {
              const payload = result.payload as AuthenticationResult;
              this.msalService.instance.setActiveAccount(payload.account);
          });

        this.spiner.show();
        race(
          this.msalBroadcastService.inProgress$
            .pipe(
              filter(
                (status: InteractionStatus) => status === InteractionStatus.None
              )
            ),
          timer(1000).pipe( // 1 second timeout
            map(async () => {
              console.warn('MSAL InteractionStatus.None not received, reloading...');
              //window.location.reload();
              //return null;
            })
          )
        )
          .pipe(
            takeUntil(this._destroying$),
            finalize(async () => {
              // Hide spinner in case of any completion
              this.spiner.hide();
              //await this.msalService.instance.initialize();
            })
          )
          .subscribe(async (result) => {
            if(result){
              if (!this.authenticated) {
                if (!this.isLoggedIn) {
                  this.clearSiteData();
                }
                //await this.logIn();
              } else {
                let info = this.msalService.instance.getAllAccounts()[0];
                this.userService
                  .getUserRole(info.idTokenClaims.preferred_username)
                  .subscribe({
                    next: async (data) => {
                      let roleNum = Number(data);
                      userObj.role = this.mapRoleNumber(roleNum);
                      userObj.username = info.idTokenClaims.preferred_username;
                      userObj.firstName = info.idTokenClaims.name.split(" ")[0];
                      userObj.lastName = info.idTokenClaims.name.split(" ")[1];
                      userObj.id = info.idTokenClaims.oid;
                      this.msalService
                        .acquireTokenSilent({
                          account: info,
                          scopes: ["user.read"],
                        })
                        .subscribe((data) => {
                          userObj.token = data.idToken;
                          this.handleAfterLogin(userObj);
                          this.universalSub = this.navService.breadcrumbEntity.subscribe(x => {
                            if (this.currentEntity != x) {
                              this.currentEntity = x;
                            }
                          });
                        });
                    },
                    error: () => {
                      if (!this.isLoggedIn) {
                        this.clearSiteData();
                      }
                      this.isLoggedIn = false;
                      //this.msalService.logout();
                    },
                  });
              }
            }
          });
      }

    } else {
      this.spiner.show();
      this.isLoggedIn = localStorage.getItem("currentUser") ? true : false;
      this.isJobOperator = this.authenticationService.getRole() === UserRoleNames.JobOperator;
      this.universalSub = this.navService.breadcrumbEntity.subscribe(x => {
        if (this.currentEntity != x) {
          this.currentEntity = x;
        }
      })
      this.isPathConfigurator = true;
      this.navService.subNavData(Entities.Home);
      this.deployments = this.depService.getProfileInfoesFromSubject();
      if (this.deployments) { this.spiner.hide() }
      await this.loadDepList()
      this.dataReloadSubscription = interval(this.syncConfig.config.deployments.listReqInterval).subscribe(async (x) => {
        await this.loadDepList()
      });
      this.depService.initializeHeadnodeData();
    }
  }

  clearSiteData() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }

  async logIn() {
    await this.msalService.instance.loginRedirect();
  }

  get authenticated(): boolean {
    return this.msalService.instance.getActiveAccount() ? true : false;
  }

  checkLicenseExpiry() {
    return this.configEntityService.checkIfLoginEnabled().pipe(
      map((data: any) => {
        let isLoginEnabled = data;
        if (isLoginEnabled === false) {
          localStorage.setItem("LicenseExpired", "true");
        }
        return !isLoginEnabled;
      }),
      catchError((err) => {
        console.error(err);
        return of(true);
      })
    );
  }

  private mapRoleNumber(roleNum: number): string {
    switch (roleNum) {
      case 0:
        return UserRoleNames.GlobalAdmin;
      case 1:
        return UserRoleNames.DeploymentAdmin;
      case 2:
        return UserRoleNames.PowerUser;
      case 3:
        return UserRoleNames.JobOperator;
      case 4:
        return UserRoleNames.Reader;
      default:
        return "";
    }
  }

  checkIfUserIsVdiOnly(userName) {
    return this.authenticationService.isUserVdiOnly(userName).pipe(
      map((data: any) => {
        let isVdiUserEnabled = data;
        if (isVdiUserEnabled === false) {
          localStorage.setItem("isUserVdiOnly", "false");
        }
        return !isVdiUserEnabled;
      }),
      catchError((err) => {
        console.error(err);
        return of(true);
      })
    );
  }

  async handleAfterLogin(userObj) {
    // check if user is vdi user or not make a call to the backend
    localStorage.setItem("currentUser", JSON.stringify(userObj));
    this.authenticationService.updateCurrentUserValue(userObj);
    const licenseExpired = await lastValueFrom(this.checkLicenseExpiry());
    const userSessionAdded = await lastValueFrom(this._concurrentService.add());
    const isUserVdiOnly = await lastValueFrom(
      this.checkIfUserIsVdiOnly(userObj.username)
    );

    localStorage.setItem(
      "currentUser",
      JSON.stringify({
        ...userObj,
        isUserVdiOnly: isUserVdiOnly,
      })
    );

    if (userSessionAdded != true) {
      this.snackbar.open(userSessionAdded as string, "Ok", {
        duration: 5000,
      });
      setTimeout(() => {
        this.authenticationService.logout();
      }, 1000);
    } else {
      if (!licenseExpired) {
        if (this.isClientLogin) {
          this.router.navigate(["/Client Sessions/desktopapp/sessions"]);
        } else if (this.vdiModeOnly && isUserVdiOnly && !this.isClientLogin) {
          this.router.navigate(["/Client Sessions/webapp/sessions"]);
        } else {
          if (userObj?.role == UserRoleNames.Reader) {
            this.isLoggedIn = localStorage.getItem("currentUser") ? true : false;
            this.isJobOperator = this.authenticationService.getRole() === UserRoleNames.JobOperator;
            this.router.navigate(["/Analytics"]);
          }
          else if (userObj?.role == UserRoleNames.GlobalAdmin) {
            this.isLoggedIn = localStorage.getItem("currentUser") ? true : false;
            this.isJobOperator = this.authenticationService.getRole() === UserRoleNames.JobOperator;
            this.isPathConfigurator = true;
            this.navService.subNavData(Entities.Home);
            this.deployments = this.depService.getProfileInfoesFromSubject();
            if (this.deployments) { this.spiner.hide() }
            await this.loadDepList()
            this.dataReloadSubscription = interval(this.syncConfig.config.deployments.listReqInterval).subscribe(async (x) => {
              await this.loadDepList()
            });
            this.router.navigate(["/Home"]);
          }
          else {
            this.router.navigate(["/Job List"]);
          }
        }
      } else {
        this.router.navigate(["/Configurator"]);
      }
    }
    this.depService.initializeHeadnodeData();
  }

  async loadDepList() {
    this.universalSub = await this.depService
      .getAllDeploymentsForUser()
      .subscribe({
        next: (data) => {
          if (data == null) {
            this.spiner.hide()
            this.dataEmpty = true;
          } else {
            this.deployments = <Deployment[]>JSON.parse(JSON.stringify(data));
            this.headerService.updateDeploymentList(this.deployments);
            this.depService.emptyUserAccess();
            this.depService.checkUserDepAccess();
            if (this.deployments.length == 0) {
              this.dataEmpty = true;
              this.spiner.hide();
              return;
            }
            this.dataEmpty = false;
            this.spiner.hide();
          }
        }, error: (err) => {
          this.spiner.hide()
          this.dataEmpty = true;
        }
      }
      );
  }

  ngOnDestroy() {
    if (this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
    if (this.universalSub) {
      this.universalSub.unsubscribe()
    }
    if (this.snackbar) {
      this.snackbar.dismiss();
    }
    if (this.userDepCheck) this.userDepCheck.unsubscribe();
  }

  redirectTo(deployment: Deployment) {
    if (deployment.status != 'Provisioning..') {
      this.clickedDepName = deployment.name;
      if (this.currentEntity == 'Configurator') {
        this.router.navigate([deployment.cloud, this.clickedDepName, 'settings'], { relativeTo: this.route });
        this.navService.sendParentData(this.clickedDepName)
      } else {
        this.router.navigate([
          "Home",
          deployment.cloud,
          this.clickedDepName
        ])
        // this.router.navigate([deployment.cloud, this.clickedDepName], { relativeTo: this.route });
        this.navService.sendChildData(this.clickedDepName);
        this.storageService.sendActiveStorageName(deployment.storageAccountName)
      }
    } else {
      this.snackbar.open('Selected Deployment is in progress. Check Status for more info.', 'Ok')
    }
  }

  addDeployment(providerValue: number, providerName: string) {
    const dialogRef = this.dialog.open(AddDeploymentComponent, {
      width: '60%',
      autoFocus: true,
      disableClose: true,
      data: { cloudValue: providerValue, cloudName: providerName }
    })
    dialogRef.afterClosed().subscribe(async res => {
      if (res) {
        this.snackbar.open('Deployment Created Successfully, Wait For Some Time To be Active or Refresh Page.', 'Ok',
          {
            duration: 3000
          })
        await this.loadDepList();
      }
    })
  }

  checkDepStatus(deploymentName: string, depId: string) {
    this.dialog.open(JobOutputDialogComponent, {
      width: '90%',
      autoFocus: false,
      disableClose: true,
      hasBackdrop: false,
      id: "jobOutputDialogJobs",
      data: { depName: deploymentName, depId: depId, path: "", id: "jobOutputDialogJobs" },
      panelClass: 'custom-output-dialog-container'
    });
  }

  deleteDeployment(depName: string) {
    const dialogRef = this.dialog.open(DeleteDeploymentComponent, {
      width: '30%',
      autoFocus: true,
      disableClose: true,
      data: { name: depName, type: 'deployment' },
    })
    dialogRef.afterClosed().subscribe(async res => {
      if (res) {
        this.depService.deleteDeployment(depName, res?.returnObject?.skipCloud).subscribe({
          next: (data) => {
            this.spiner.show();
            this.snackbar.open('Deployment Deleted Successfully, Wait For Some Time or Refresh Page Once.', 'Ok',
              {
                duration: 3000
              })
            this.loadDepList();
            this.locationReload()
          },
          error: (error) => {
            this.snackbar.open(error?.error?.message || 'Failed to delete deployment.', 'Ok', { duration: 3000 })
          }
        });
      }
    })
  }

  sortByName() {
    if (this.sortName == 0) {
      this.deployments.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
    }
    if (this.sortName == 1) {
      this.deployments.sort((a, b) => 0 - (b.name.toLowerCase() > a.name.toLowerCase() ? 1 : -1));
    }
    this.sortName++
    if (this.sortName == 2) {
      this.sortName = 0;
    }
  }

  sortByLocation() {
    if (this.sortLocation == 0) {
      this.deployments.sort((a, b) => 0 - (a.location.toLowerCase() > b.location.toLowerCase() ? 1 : -1));
    }
    if (this.sortLocation == 1) {
      this.deployments.sort((a, b) => 0 - (b.location.toLowerCase() > a.location.toLowerCase() ? 1 : -1));
    }
    this.sortLocation++
    if (this.sortLocation == 2) {
      this.sortLocation = 0;
    }
  }

  sortByScheduler() {
    if (this.sortScheduler == 0) {
      this.deployments.sort((a, b) => 0 - (a.scheduler.toLowerCase() > b.scheduler.toLowerCase() ? 1 : -1));
    }
    if (this.sortScheduler == 1) {
      this.deployments.sort((a, b) => 0 - (b.scheduler.toLowerCase() > a.scheduler.toLowerCase() ? 1 : -1));
    }
    this.sortScheduler++
    if (this.sortScheduler == 2) {
      this.sortScheduler = 0;
    }
  }

  sortByInfrastructure() {
    if (this.sortInfrastructure == 0) {
      this.deployments.sort((a, b) => 0 - (a.cloud.toLowerCase() > b.cloud.toLowerCase() ? 1 : -1));
    }
    if (this.sortInfrastructure == 1) {
      this.deployments.sort((a, b) => 0 - (b.cloud.toLowerCase() > a.cloud.toLowerCase() ? 1 : -1));
    }
    this.sortInfrastructure++
    if (this.sortInfrastructure == 2) {
      this.sortInfrastructure = 0;
    }
  }
  sortByStatus() {
    if (this.sortStatus == 0) {
      this.deployments.sort((a, b) => 0 - (a.status.toLowerCase() > b.status.toLowerCase() ? 1 : -1));
    }
    if (this.sortStatus == 1) {
      this.deployments.sort((a, b) => 0 - (b.status.toLowerCase() > a.status.toLowerCase() ? 1 : -1));
    }
    this.sortStatus++
    if (this.sortStatus == 2) {
      this.sortStatus = 0;
    }
  }
  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  locationReload() {
    location.reload();
  }

  redirectToCloudProviders(depType: string) {
    localStorage.setItem('cloudProvider', depType);
    //this.depService.newDepType = depType;
    this.router.navigate(['new'], { relativeTo: this.route });
  }

  checkIfOnPremiseDeployment(cloud: string) {
    return cloud == CloudTypes.OnPremise;
  }

  defaultAdminLogin() {
    this.spiner.show();
    this.isLoggedIn = localStorage.getItem("currentUser") ? true : false;
    this.isJobOperator = this.authenticationService.getRole() === UserRoleNames.JobOperator;
    this.universalSub = this.navService.breadcrumbEntity.subscribe(x => {
      if (this.currentEntity != x) {
        this.currentEntity = x;
      }
    })
    this.isPathConfigurator = true;
    this.navService.subNavData(Entities.Home);
    this.deployments = this.depService.getProfileInfoesFromSubject();
    if (this.deployments) { this.spiner.hide() }
    this.loadDepList()
    this.dataReloadSubscription = interval(this.syncConfig.config.deployments.listReqInterval).subscribe((x) => {
      this.loadDepList()
    });
  }
}
